export default "__VITE_ASSET__lVi0L2n$__"